import type { Language } from '../i18n'
import { useLanguage } from '../i18n'

/**
 * The BCP-47 tag behind the two-letter UI language, for `Intl`.
 *
 * Polish uses a comma as the decimal separator and a space as the thousands
 * separator; getting `12,4 km` rather than `12.4 km` is the whole point.
 */
const LOCALES: Record<Language, string> = {
  pl: 'pl-PL',
  en: 'en-GB',
}

export const useLocale = (): string => LOCALES[useLanguage().language]
